import { isSafari, isMobileSafari } from 'react-device-detect';

export function AudioPlay(sound: string) {
  if (isSafari || isMobileSafari) {
    return;
  }
  const url = `/audio/${sound}.mp3`;
  const playSound = new Audio(url);
  playSound.currentTime = 0;
  playSound.muted = false;
  playSound.play();
}
